// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSnackbar-Label_cls1__eD+Xd","cls2":"VeloSnackbar-Label_cls2__0VHlp VeloSnackbar-Label_cls1__eD+Xd"};